export default __webpack_public_path__ + "static/media/watch.37951fcc.png";